import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-plans-status-settings',
    templateUrl: './plans-status-settings.component.html',
    styleUrls: ['./plans-status-settings.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class PlansStatusSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;

    //settings
    public defaultRangeStart = 70;
    public defaultRangeEnd = 90;
    public prevRangeStart = 0;
    public prevRangeEnd = 0;
    public range = [this.defaultRangeStart, this.defaultRangeEnd];
    public showSlider = true;

    //Old Settings Layout
    public nameMxSz = 35;

    public automaticQualityPlan = true;

    constructor(
        private cvLocalizationService: CVLocalizationService,
    ) { }

    ngOnInit(): void {
        this.moduleManager.registerEvents({
            onSettingsOpened: this.onSettingsOpened.bind(this),
            onSettingsCancelled: this.onSettingsCancelled.bind(this)
        });

        this.moduleManager.addSetting({
            name: 'MidRangeStart',
            getValue: () => Number.isInteger(this.range[0]) ? this.range[0] : this.defaultRangeStart,
            onSettingLoaded: value => {
                this.range[0] = Number(value);
                if (value === "")
                    this.range[0] = Number(this.defaultRangeStart);
            },
            defaultValue: this.defaultRangeStart,
        });

        this.moduleManager.addSetting({
            name: 'MidRangeEnd',
            getValue: () => Number.isInteger(this.range[1]) ? this.range[1] : this.defaultRangeEnd,
            onSettingLoaded: value => {
                this.range[1] = Number(value);
                if (value === "")
                    this.range[1] = Number(this.defaultRangeEnd);
            },
            defaultValue: this.defaultRangeEnd,
        });

        this.moduleManager.addSetting({
            name: 'automaticQualityPlan',
            required: true,
            getValue: () => this.automaticQualityPlan,
            onSettingLoaded: value => {
                this.automaticQualityPlan = value !== undefined ? value : true;
            },
        });

        this.moduleManager.customSettingsAdded = true;
    }

    onSettingsOpened() {
        this.prevRangeStart = this.range[0];
        this.prevRangeEnd = this.range[1];
        this.showSlider = true;
    }

    onSettingsCancelled() {
        this.range[0] = this.prevRangeStart;
        this.range[1] = this.prevRangeEnd;
        this.showSlider = false;
    }

    validateName(e) {
        if (this.moduleManager.moduleOptions.editName.length > this.nameMxSz)
            this.moduleManager.moduleOptions.editName = this.moduleManager.moduleOptions.editName.substring(0, this.nameMxSz);
    }

    getLocalizationString(key, defaultValue): string {
        const baseString = this.cvLocalizationService.getCachedText("CXOne_Modal", key, defaultValue);
        return baseString;
    }
}
